import DownloadPdfButton from "./modules/DownloadPdfButton";
import FrontendListing from "./modules/FrontendListing";
import Popup from "./modules/Popup";
import ViewProfileDetails from "./modules/ViewProfileDetails";

const proModules = () => {
	const modules = [
		ViewProfileDetails,
		Popup,
		FrontendListing,
		DownloadPdfButton
	];

	return modules;
};

export default proModules;
